import { createSlice } from "@reduxjs/toolkit";

export const get_Growth_Stages = createSlice({
  name: "crop_disease",
  initialState: {
    value: { status: false, data: {} },
  },
  reducers: {
    updateStoreGrowthStages: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateStoreGrowthStages } = get_Growth_Stages.actions;

export default get_Growth_Stages.reducer;
